module.exports = __webpack_public_path__ + "videos/mts-main-products-comdi.80bf37d.mp4";